import type { WineColor } from '@gwc/shared';
import { api } from '../lib/api';
import type {
  CatalogWineListItem,
  CatalogWineDetail,
  WineAppearance,
  WineStats,
} from './models';

export interface WineCatalogInput {
  wineName: string;
  producer?: string;
  varietals?: string[];
  regionAva?: string;
  country?: string;
  vineyard?: string;
  vintage?: number | null;
  color?: WineColor | null;
  abv?: number | null;
  typicalPrice?: number | null;
  drinkFrom?: number | null;
  drinkTo?: number | null;
  labelImageUrl?: string;
  tastingNotes?: string;
  notes?: string;
}

export interface WineCatalogSearch {
  q?: string;
  producer?: string;
  varietal?: string;
  regionAva?: string;
  country?: string;
  color?: WineColor;
  vintage?: number;
  page?: number;
  pageSize?: number;
}

export type LookupKind = 'producers' | 'varietals' | 'regions' | 'venues';

export const winesApi = {
  search: (params: WineCatalogSearch = {}) => {
    const qs = new URLSearchParams(
      Object.entries(params)
        .filter(([, v]) => v != null && v !== '')
        .map(([k, v]) => [k, String(v)]),
    ).toString();
    return api.get<{ items: CatalogWineListItem[]; total: number; page: number; pageSize: number }>(
      `/wines${qs ? `?${qs}` : ''}`,
    );
  },
  get: (id: string) =>
    api.get<{ wine: CatalogWineDetail; appearances: WineAppearance[]; stats: WineStats }>(`/wines/${id}`),
  create: (body: WineCatalogInput) => api.post<{ id: string }>('/wines', body).then((r) => r.id),
  update: (id: string, body: Partial<WineCatalogInput>) => api.patch<{ ok: true }>(`/wines/${id}`, body),
  remove: (id: string) => api.del<{ ok: true }>(`/wines/${id}`),
  lookup: (kind: LookupKind, q: string) =>
    api
      .get<{ items: string[] }>(`/wines/lookups/${kind}?q=${encodeURIComponent(q)}`)
      .then((r) => r.items),
};
